<template>
  <v-dialog
    :value="show"
    @input="close" max-width="700" persistent
  >
    <v-card>
      <v-card-title class="text-h5">
        <slot>
          Вы действительно хотите удалить?
        </slot>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          depressed
          color="error"
          @click="$emit('confirm')"
          :disabled="loading"
          :loading="loading"
        >
          Удалить
        </v-btn>
        <v-btn
          depressed
          :disabled="loading"
          :loading="loading"
          @click="$emit('cancel'); close()"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DeleteConfirmDialog',
    emits: [
      'confirm',
      'cancel',
      'input',
    ],
    model: {
      prop: 'show',
      event: 'input',
    },
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },

    },
    methods: {
      close (val = false) {
        this.$emit('input', val)
      },
    },
  }

</script>

<style scoped lang="less">

</style>
